<template>
  <footer
    v-if="totalItems > 0"
    class="bg-white dark:bg-slate-800 h-[60px] border-t border-solid border-slate-75 dark:border-slate-700/50 flex items-center justify-between py-0 px-4"
  >
    <div class="left-aligned-wrap">
      <div class="text-xs text-slate-600 dark:text-slate-200">
        <strong>{{ firstIndex }}</strong> - <strong>{{ lastIndex }}</strong> of
        <strong>{{ totalItems }}</strong> items
      </div>
    </div>
    <div class="right-aligned-wrap flex">
      <div class="primary button-group pagination-button-group items-center">
        <select
          class="form-select bg-white dark:bg-slate-800 h-[32px] w-[40%] mb-0 mr-4 text-xs text-slate-600 dark:text-slate-200"
          :value="perPage"
          @change="onPerPageChange"
        >
          <option
            v-for="option in itemsPerPageOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>

        <woot-button
          size="small"
          variant="smooth"
          color-scheme="secondary"
          :is-disabled="!hasPrevPage"
          @click="onFirstPage"
        >
          <fluent-icon icon="chevron-left" size="18" />
          <fluent-icon icon="chevron-left" size="18" />
        </woot-button>

        <woot-button
          size="small"
          variant="smooth"
          color-scheme="secondary"
          :is-disabled="!hasPrevPage"
          @click="onPrevPage"
        >
          <fluent-icon icon="chevron-left" size="18" />
        </woot-button>

        <woot-button size="small" variant="smooth" color-scheme="secondary">
          {{ currentPage }}
        </woot-button>

        <woot-button
          size="small"
          variant="smooth"
          color-scheme="secondary"
          :is-disabled="!hasNextPage"
          @click="onNextPage"
        >
          <fluent-icon icon="chevron-right" size="18" />
        </woot-button>

        <woot-button
          size="small"
          variant="smooth"
          color-scheme="secondary"
          :is-disabled="!hasNextPage"
          @click="onLastPage"
        >
          <fluent-icon icon="chevron-right" size="18" />
          <fluent-icon icon="chevron-right" size="18" />
        </woot-button>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    firstIndex: Number,
    lastIndex: Number,
    totalItems: Number,
    currentPage: Number,
    perPage: Number,
    hasPrevPage: Boolean,
    hasNextPage: Boolean,
    itemsPerPageOptions: {
      type: Array,
      default: () => [10, 25, 50, 100],
    },
  },
  methods: {
    onPerPageChange(event) {
      const value = Number(event.target.value);
      this.$emit('update:perPage', value);
      this.$emit('per-page-change', value);
    },
    onFirstPage() {
      this.$emit('first-page');
    },
    onNextPage() {
      this.$emit('next-page');
    },
    onPrevPage() {
      this.$emit('prev-page');
    },
    onLastPage() {
      this.$emit('last-page');
    },
  },
};
</script>
